<h1 mat-dialog-title>{{'Shared.Attention' | translate}}</h1>
<mat-dialog-content>
  {{ this.data.promptText | translate}}
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="true">{{ this.data.submitText | translate}}</button>
  <button mat-button [mat-dialog-close]="false">{{'Shared.Cancel' | translate}}</button>
</mat-dialog-actions >
